import script from "./TraitShop.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShop.vue?vue&type=script&setup=true&lang=js"

import "./TraitShop.vue?vue&type=style&index=0&id=14468b3e&lang=scss"

const __exports__ = script;

export default __exports__